import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './FAQSearch';

const FAQSearchSuspense = dynamic(() => import('./FAQSearch'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicFAQSearch(props: Props) {
	return <FAQSearchSuspense {...props} />;
}
DynamicFAQSearch.displayName = 'DynamicFAQSearch';
